import { SECTORS } from "@/lib/content";

export default function Sectors() {
  return (
    <section id="sectors" data-testid="sectors-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">04 — Sectors We Serve</span>
          </div>
          <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em]">
            Working with <em className="text-gold not-italic">institutions</em> across sectors.
          </h2>
        </div>

        <div className="flex flex-wrap gap-3 md:gap-4">
          {SECTORS.map((sector, i) => (
            <span
              key={sector.name}
              data-testid={`sector-pill-${i}`}
              className="inline-flex items-center px-5 md:px-6 py-3 md:py-3.5 border border-softgray
                         text-navy text-sm md:text-[15px] font-medium rounded-full
                         hover:bg-navy hover:text-white hover:border-navy transition-colors duration-300 cursor-default"
            >
              {sector.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
